/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AgeInputs */

const en__field_age = /** @type {(inputs: _Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age`)
};

const de__field_age = /** @type {(inputs: _Field_AgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alter`)
};

/**
* | output |
* | --- |
* | "Age" |
*
* @param {_Field_AgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_age = /** @type {((inputs?: _Field_AgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_age(inputs)
	return de__field_age(inputs)
});